const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Company Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Companies', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/companies/:resource/:subresource', null, {
    get: {params: {}, method: 'GET', isArray: false},
    checkAlternativeLogins: {params: {resource: 'check-alternative-logins', subresource: ''}, method: 'GET', isArray: false},
    googleAnalytics: {params: {resource: 'google-analytics', subresource: ''}, method: 'POST', isArray: false},
    setTheme: {params: {resource: 'theme-cards', subresource: ''}, method: 'POST', isArray: false}
  });

}]);